<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div class="col-md-6">
        <label for="point_name" class="form-control-label">
          Nombre<span class="required">*</span>
        </label>
        <input
          id="point_name"
          v-model="formModel.name"
          :class="[
                        'form-control',
                        v.name.$error ? 'is-invalid' : '',
                      ]"
          type="text"
          placeholder=""
        />
        <p v-if="v.name.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.name.$errors[0].$message }}
          </small>
        </p>
        <label for="video" class="form-control-label">
          Icono<span class="required">*</span>
        </label>
        <a :href="formModel.imageUrl" target="_blank">
          <img v-if="formModel.imageUrl" class="img-thumbnail d-block" width="150" :src="formModel.imageUrl" />
        </a>
        <input
            type="file"
            id="video"
            @change="uploadImage"
            :class="[ 'form-control']"
            placeholder="Icono"
        />
        <label for="description" class="form-control-label">
          Descripción<span class="required">*</span>
        </label>
        <textarea
            rows="10"
            id="description"
            v-model="formModel.description"
            :class="[
                        'form-control',
                        v.description.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="v.description.$error" class="invalid-feedback invalid-field mb-0">
          <small>
            {{ v.description.$errors[0].$message }}
          </small>
        </p>
      </div>
    </div>
    <div class="mt-3">
      <button
        type="submit"
        class="float-end btn btn-primary text-white bg-blue-600 rounded-lg border border-primary hover:bg-blue-900">
        {{ buttonText }}
      </button>
      <button
        class="me-2 float-end btn btn-primary text-danger bg-white border border-danger rounded-lg hover:bg-blue-900"
        @click="handleCancel"
      >
        Cancelar
      </button>
    </div>
  </form>
</template>

<script setup>
import {ref, defineProps, computed} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from 'sweetalert2';
const store = useStore();
const router = useRouter();

const props = defineProps({
   entity: {
     type: Object,
     required: false
   },
  action: {
     type: String,
    required: true
  }
})
const formModel = ref(props.entity|| {});

const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');

const rules = computed(() => {
  return {
    name: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    description: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    imageUrl: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    }
  };
});

const v$ = useVuelidate(rules, formModel);
const v = v$.value;

const handleSubmit = () => {
  v$.value.$validate();
  if (!v$.value.$invalid) {
    if(props.action === 'create'){
      createEntity(formModel.value);
    }else{
      updateEntity(formModel.value);
    }
  }
};

const handleCancel = () => {
  router.push({ name: "TipoExperiencias", params: {} });
};

const updateEntity = async (data) => {
  try {
    await store.dispatch("experienceType/edit", data).then(() =>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Punto de interés editado satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
    });
    await router.push({ name: "TipoExperiencias", params: {} });
  } catch (error) {
    await Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: 'Se ha producido un error.',
      showConfirmButton: false,
      timer: 3000
    })
    console.log(error);
  }
};

const createEntity = async (data) => {
  try {
    await store.dispatch("experienceType/add", data).then(async () => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Tipo de experiencia creado satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      router.push({name: "TipoExperiencias", params: {}});
    })
  }catch (error) {
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: error.response.data['hydra:description'],
        showConfirmButton: false,
        timer: 3000
      })
    }
}
const createImage= (file) => {
  if (typeof FileReader === "undefined") {
    alert(
        "Su navegador no admite carga de ficheros, actualice su navegador"
    );
    return false;
  }

  for (let i = 0; i < file.length; i++) {
    const reader = new FileReader();
    reader.readAsDataURL(file[i]);
    reader.onload = function(e) {
      formModel.value.image = e.target.result;
      formModel.value.imageUrl = reader.result
    };
  }
}
const uploadImage = (e) => {
  const files = e.target.files || e.dataTransfer.files;
  if (!files.length) return;
  createImage(files);
}
</script>
